export const storage = {
  hash: '@eulalia/hash',
  showPushCount: '@eulalia/showPushCount',
  showPushInfoAlert: '@eulalia/showPushInfoAlert',
  enabledInitCount: '@eulalia/enabledInitCount',
};
